import all from './all';
import store from './store';
import show from './show';
import update from './update';
import destroy from './destroy';

export default {
  all,
  store,
  show,
  update,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/recipeProcedure/index.js